import { Injectable } from '@angular/core';
import { DialogService } from '@controladad/ng-base';
import {
  ProfileDialogComponent,
  ProfileDialogData,
  ProfileDialogResult,
} from './components/profile-dialog/profile-dialog.component';
import { DetailsDialogComponent, DetailsDialogData } from './components/details-dialog/details-dialog.component';
import { PropertyDialogComponent, PropertyDialogData } from './components/property-dialog/property-dialog.component';
import {
  PropertyHistoryDialogComponent,
  PropertyHistoryDialogData,
} from './components/property-history-dialog/property-history-dialog.component';
import { UserDialogComponent, UserDialogData, UserDialogResult } from './components/user-dialog/user-dialog.component';
import { PlanDialogComponent, PlanDialogData } from './components/plan-dialog/plan-dialog.component';
import { AssetTrackingReportDialogComponent, AssetTrackingReportDialogData, AssetTrackingReportDialogResult } from './components/asset-tracking-report-dialog/asset-tracking-report-dialog.component';
import { DiscoveredPropertyDialogComponent, DiscoveredPropertyDialogData } from './components/discovered-property-dialog/discovered-property-dialog.component';
import { ConflictDialogComponent, ConflictDialogData, ConflictDialogResult } from './components/conflict-dialog/conflict-dialog.component';
import { RoleDialogComponent, RoleDialogData, RoleDialogResult } from './components/role-dialog/role-dialog.component';
import { LateRecordsDialogComponent, LateRecordsDialogData } from './components/late-records-dialog/late-records-dialog.component';
import { LocationHistoryDialogComponent, LocationHistoryDialogData } from './components/location-history-dialog/location-history-dialog.component';
import { TreeDialogComponent, TreeDialogData } from './components/tree-dialog/tree-dialog.component';
import { TagStatusDialogComponent, TagStatusDialogData } from './components/tag-status-dialog/tag-status-dialog.component';
import { LocationDialogComponent, LocationDialogData } from './components/location-dialog/location-dialog.component';

@Injectable({
  providedIn: 'root',
})
export class DialogExtendedService extends DialogService {
  // Some predefined dialogs are already available in the parent service.
  // public something(p: string) {
  //   return super.prompt({
  //     title: 'LOOOK',
  //     message: 'SOMETHING!!',
  //   });
  // }
  // product(data?: ProductDialogData) {
  //   return this.dialog.open<ProductDialogComponent, ProductDialogData, ProductDialogResult>(
  //     ProductDialogComponent,
  //     data,
  //   );
  // }

  profile(data?: ProfileDialogData) {
    return this.dialog.open<ProfileDialogComponent, ProfileDialogData, ProfileDialogResult>(
      ProfileDialogComponent,
      data,
    );
  }

  details<T, U>(data: DetailsDialogData<T, U>) {
    return this.dialog.open<DetailsDialogComponent<T, U>, DetailsDialogData<T, U>, any>(DetailsDialogComponent, data);
  }

  property<T, U>(data: PropertyDialogData) {
    return this.dialog.open<PropertyDialogComponent, PropertyDialogData, any>(
      PropertyDialogComponent,
      data,
      { width: '65rem', maxWidth: '90vw', maxHeight: '90vh' },
    );
  }

  plan(data?: PlanDialogData) {
    return this.dialog.open<PlanDialogComponent, PlanDialogData, any>(
      PlanDialogComponent,
      data,
      { width: '60rem', maxWidth: '90vw', maxHeight: '90vh' },
    );
  }

  propertyHistory<T, U>(data: PropertyHistoryDialogData) {
    return this.dialog.open<PropertyHistoryDialogComponent, PropertyHistoryDialogData, any>(
      PropertyHistoryDialogComponent,
      data,
      { width: '90vw', maxWidth: '90vw', height: '90vh', maxHeight: '90vh', autoFocus: false },
    );
  }

  user(data?: UserDialogData) {
    return this.dialog.open<UserDialogComponent, UserDialogData, UserDialogResult>(
      UserDialogComponent,
      data,
    );
  }

  assetTrackingReport(data?: AssetTrackingReportDialogData) {
    return this.dialog.open<AssetTrackingReportDialogComponent, AssetTrackingReportDialogData, AssetTrackingReportDialogResult>(
      AssetTrackingReportDialogComponent,
      data,
      { width: '65rem', maxWidth: '90vw', maxHeight: '90vh' },
    );
  }

  discoveredProperty<T, U>(data: DiscoveredPropertyDialogData) {
    return this.dialog.open<DiscoveredPropertyDialogComponent, DiscoveredPropertyDialogData, any>(
      DiscoveredPropertyDialogComponent,
      data,
      { width: '65rem', maxWidth: '90vw', maxHeight: '90vh' },
    );
  }

  conflict(data?: ConflictDialogData) {
    return this.dialog.open<ConflictDialogComponent, ConflictDialogData, ConflictDialogResult>(
      ConflictDialogComponent,
      data,
      { width: '40rem', maxWidth: '90vw', maxHeight: '90vh' },
    );
  }

  role(data: RoleDialogData) {
    return this.dialog.open<RoleDialogComponent, RoleDialogData, RoleDialogResult>(
      RoleDialogComponent,
      data,
      { width: '90rem', maxWidth: '90vw', height: '90vh', maxHeight: '90vh' },
    );
  }

  lateRecords(data: LateRecordsDialogData) {
    return this.dialog.open<LateRecordsDialogComponent, LateRecordsDialogData, any>(
      LateRecordsDialogComponent,
      data,
      { width: '90vw', maxWidth: '90vw', height: '90vh', maxHeight: '90vh' },
    );
  }

  locationHistory(data: LocationHistoryDialogData) {
    return this.dialog.open<LocationHistoryDialogComponent, LocationHistoryDialogData, any>(
      LocationHistoryDialogComponent,
      data,
      { width: '90vw', maxWidth: '90vw', height: '90vh', maxHeight: '90vh', autoFocus: false },
    );
  }

  tree(data: TreeDialogData) {
    return this.dialog.open<TreeDialogComponent, TreeDialogData, any>(
      TreeDialogComponent,
      data,
      { width: '90vw', maxWidth: '90vw', height: '90vh', maxHeight: '90vh' },
    );
  }

  tagStatus(data: TagStatusDialogData) {
    return this.dialog.open<TagStatusDialogComponent, TagStatusDialogData, any>(
      TagStatusDialogComponent,
      data,
      { width: '50vw', maxWidth: '90vw', height: '60vh', maxHeight: '90vh', autoFocus: false },
    );
  }

  location(data: LocationDialogData) {
    return this.dialog.open<LocationDialogComponent, LocationDialogData, any>(
      LocationDialogComponent,
      data,
      { width: '50vw', maxWidth: '90vw'},
    );
  }
}
